export const SOCKET_EVENTS = {
  CHANNEL: {
    JOIN_CHANNEL: 'WS:JOIN_CHANNEL',
    LEAVE_CHANNEL: 'WS:LEAVE_CHANNEL',
  },
};
